import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import React, { useState } from "react";
import { getRoleList } from "../../../../services/workspace/role.service";
import {
  createDataTransformer,
  presetTransformers,
} from "../../../../utils/dataTransformers";
import {
  createActionButtons,
  commonConditions,
  createProtectedActionButtons,
} from "../../../../utils/actionButtonHelpers";
import { useNavigate } from "react-router-dom";
import { usePermissionCheck } from "../../../../hooks";

export const actions_type = {
  DELETE: "DELETE",
  ADD_EDIT: "ADD_EDIT",
};

export const items = [{ label: "Role", path: "" }];
const Role = () => {
  const navigate = useNavigate();
  const permissions = usePermissionCheck("configuration", "role");
  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    // New sorting helpers
    sortingUIProps,
  } = useCommonFetch(getRoleList, {
    dataPath: "role.data",
    totalPath: "role.meta.total",
    errorMessage: "Failed to fetch role data!",
    debounceDelay: 500,
    // Dynamic sorting configuration
    // sortingOptions: [

    //   { label: "Name", field: "name" },
    //   { label: "Date", field: "created_at" },
    // ],
    // sortingModule: "role",
    // orderParamNames: { orderByKey: "order_by", orderTypeKey: "order_type", includeDisabledKey: "includeDisabled" },
    // sortingDisableText: "Disabled",
    // sortingShowDisableToggle: false,
    // Optimized data transformer using utility functions
    dataTransformer: createDataTransformer(
      presetTransformers.basicEntity(null, "uuid"),
      () => {
        return createProtectedActionButtons(
          {
            edit: {
              handler: (item) => {
                // Navigate to edit page instead of opening modal
                navigate(`/configuration/role/edit/${item.id.data}`);
              },
              requirePermission: "update",
              condition: commonConditions.always,
            },
            delete: {
              handler: (item) => {
                // You can add delete functionality here if needed
                // handleDelete(item.id.data, deleteRole, {
                //   successMessage: "Role deleted successfully!",
                //   errorMessage: "Failed to delete role!",
                // });
              },
              requirePermission: "delete",
              condition: commonConditions.always,
            },
          },
          permissions
        );
      }
    ),
  });

  const TableHeaderData = [
    {
      label: "Name",
      key: "name",
    },
    {
      label: "Abbreviation",
      key: "abrv",
    },
    {
      label: "Description",
      key: "description",
    },
  ];
  // If user doesn't have view permission, don't show the page
  if (!permissions.canView) {
    return (
      <div className="flex flex-col gap-2">
        <PageTableHeader breadcrumbs={items} />
        <div className="bg-white p-8 rounded-md text-center">
          <p className="text-gray-500">You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        breadcrumbs={items}
        add={permissions.canCreate}
        onClickAdd={() => navigate("/configuration/role/add")}
      />

      <div className={"flex flex-col gap-2"}>
        <CommonTable
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />
      </div>
    </div>
  );
};
export default Role;
